module.exports = __webpack_public_path__ + "img/strategy_martin.64c02445.svg";